import React from "react";

interface MaintenanceViewModalProps {
  maintenance: any;
  onClose: () => void;
  vehicles: any[];
}

const MaintenanceViewModal: React.FC<MaintenanceViewModalProps> = ({
  maintenance,
  onClose,
  vehicles,
}) => {
  const handlePrint = () => {
    window.print();
  };
  const vehicleInfo = vehicles.find((v) => v.id === maintenance.vehicle);
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="w-full max-w-md rounded-lg bg-white p-6 shadow-lg dark:bg-gray-900"
        onClick={(e) => e.stopPropagation()}
        style={{ maxHeight: "90vh", overflowY: "auto", width: "80vw" }}
      >
        <h2 className="mb-4 text-lg font-semibold text-gray-900 dark:text-gray-100">
          Maintenance Info
        </h2>
        <div className="space-y-2">
          <div className="text-gray-900 dark:text-gray-100">
            <span className="font-semibold text-gray-700 dark:text-gray-300">
              Vehicle:
            </span>{" "}
            {vehicleInfo
              ? `${vehicleInfo.year} ${vehicleInfo.make} ${vehicleInfo.model}`
              : maintenance.vehicle}
          </div>
          <div className="text-gray-900 dark:text-gray-100">
            <span className="font-semibold text-gray-700 dark:text-gray-300">
              Date:
            </span>{" "}
            {maintenance.date}
          </div>
          <div className="text-gray-900 dark:text-gray-100">
            <span className="font-semibold text-gray-700 dark:text-gray-300">
              Status:
            </span>{" "}
            {maintenance.status}
          </div>
          <div className="text-gray-900 dark:text-gray-100">
            <span className="font-semibold text-gray-700 dark:text-gray-300">
              Maintenance Type:
            </span>{" "}
            {maintenance.maintenanceType}
          </div>
          <div className="text-gray-900 dark:text-gray-100">
            <span className="font-semibold text-gray-700 dark:text-gray-300">
              Odometer:
            </span>{" "}
            {maintenance.odometer}
          </div>
          <div className="text-gray-900 dark:text-gray-100">
            <span className="font-semibold text-gray-700 dark:text-gray-300">
              Service Provider:
            </span>{" "}
            {maintenance.serviceProvider}
          </div>
          <div className="text-gray-900 dark:text-gray-100">
            <span className="font-semibold text-gray-700 dark:text-gray-300">
              Cost:
            </span>{" "}
            {maintenance.cost}
          </div>
          <div className="text-gray-900 dark:text-gray-100">
            <span className="font-semibold text-gray-700 dark:text-gray-300">
              Notes:
            </span>{" "}
            {maintenance.notes}
          </div>
        </div>
        <div className="mt-4 flex justify-end gap-2">
          <button
            className="rounded bg-gray-200 px-4 py-2 text-gray-700 dark:bg-gray-700 dark:text-gray-200"
            onClick={onClose}
          >
            Close
          </button>
          <button
            className="rounded bg-blue-600 px-4 py-2 text-white dark:bg-blue-500"
            onClick={handlePrint}
          >
            Print
          </button>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceViewModal;
